import formatDate from '../utils/formatDate'

const formatDates = (selectTwoDates, dates) => {
  const startDate = formatDate(dates.startDate)
  const endDate = formatDate(dates.endDate)

  if (selectTwoDates) {
    return startDate ? `${startDate} - ${endDate}` : null
  }
  return startDate
}

export default formatDates
